module.exports = __webpack_public_path__ + "static/media/passid.bf4f9d8e.svg";